import RecommendedProductsTextArea from "./RecommendedProductsTextArea";
export default RecommendedProductsTextArea;
